import React, {useEffect, useRef} from 'react';
import styles from './violationModal.module.scss';
import Item from './item';
import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import useSetViolation from './hooks/useSetViolation';
import classNames from 'classnames';
const validation = Yup.object().shape({
  reason: Yup.string().required('دلیل گزارش الزامی می باشد'),
  //@ts-ignore
  description: Yup.string().when('reason', (reason: string) => {
    if (reason === 'other') {
      return Yup.string().required('متن گزارش الزامی می باشد');
    }
  }),
});
type TViolationItems = {
  id: number;
  title: string;
  value: string;
};
type TViolationModalProps = {
  open: boolean;
  handleClose: () => void;
  guid: string;
  object_type: string;
  items: TViolationItems[];
  isFarm: boolean;
};
export default function ViolationModal({
  open,
  handleClose,
  guid,
  object_type,
  items,
  isFarm,
}: TViolationModalProps) {
  const formikRef = useRef<React.MutableRefObject<undefined>>();
  const {handleSetViolation} = useSetViolation(isFarm);
  useEffect(() => {
    if (!open) {
      //@ts-ignore
      formikRef.current.setFieldValue('reason', '');
    }
  }, [open]);
  return (
    <Formik
      //@ts-ignore
      innerRef={formikRef}
      initialValues={{reason: '', description: ''}}
      validationSchema={validation}
      onSubmit={values => {
        handleSetViolation({
          reason: values.reason,
          description: values.description,
          guid,
          object_type,
        });
        handleClose();
      }}
    >
      {({values, errors, touched}) => (
        <Form>
          <div className=" px-3 pt-2">
            <div className="flex justify-between">
              {values.reason !== 'other' ? (
                <div className="flex justify-between w-full">
                  <p className=" mb-2">دلیل گزارش را انتخاب کنید</p>
                  <span className="icon-close" onClick={handleClose}></span>
                </div>
              ) : (
                <div className="flex justify-between w-full mb-5">
                  <div className="flex">
                    <span
                      className={classNames(
                        styles['violation-icon-left'],
                        ' icon-arrow_left',
                      )}
                      onClick={() =>
                        //@ts-ignore
                        formikRef.current.setFieldValue('reason', '')
                      }
                    ></span>
                    <p>دلیل گزارش را توضیح دهید</p>
                  </div>
                  <div>
                    <span
                      className="icon-close"
                      onClick={() => {
                        handleClose();
                        //@ts-ignore
                        formikRef.current.setFieldValue('reason', '');
                      }}
                    ></span>
                  </div>
                </div>
              )}
            </div>
            {values.reason !== 'other' && (
              <p className={styles['vioaltionModalGrayText']}>
                گزارش شما جهت حفظ حریم خصوصی، محفوظ باقی می‌ماند.
              </p>
            )}
            {values.reason !== 'other' ? (
              items.map(item => (
                <Item
                  value={item.value}
                  key={item.id}
                  name="reason"
                  formikRef={formikRef}
                  title={item.title}
                />
              ))
            ) : (
              <textarea
                className={styles['violation-modal-teaxtarea-field']}
                placeholder="متن گزارش"
                rows={10}
                name="description"
                onChange={e =>
                  //@ts-ignore
                  formikRef.current.setFieldValue('description', e.target.value)
                }
              ></textarea>
            )}
            {touched.reason && errors.reason && (
              <p className={styles['violation-modal-formik-errors-text']}>
                {errors.reason}
              </p>
            )}
            {touched.description && errors.description && (
              <p className={styles['violation-modal-formik-errors-text']}>
                {errors.description}
              </p>
            )}
            <div className="flex justify-between mt-2">
              <button
                className={
                  isFarm
                    ? styles['violation-modal-refuse-button-farm']
                    : styles['violation-modal-refuse-button']
                }
                type="button"
                onClick={handleClose}
              >
                انصراف
              </button>
              <button
                className={
                  isFarm
                    ? styles['violation-modal-report-button-farm']
                    : styles['violation-modal-report-button']
                }
                type="submit"
              >
                گزارش
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}
